import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { AppErrorPage, AppShell } from "@/components/app-shell/app-shell";
import Overlays, { overlaySchema } from "@/components/overlays";
import { ensureAuth } from "@/lib/auth";
const appSearchSchema = z.object({
  overlay: overlaySchema,
});

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context }) => {
    const authConfig = await ensureAuth(context.auth);

    if (!authConfig.credentials?.account) {
      throw redirect({ to: "/account/select" });
    }
  },
  errorComponent: (props) => <AppErrorPage {...props} fullScreen />,
  validateSearch: appSearchSchema,
  component: App,
});

function App() {
  const search = Route.useSearch();
  return (
    <AppShell>
      <Outlet />
      <Overlays overlay={search.overlay} />
    </AppShell>
  );
}
